/**
 * @generated SignedSource<<70deb901966a8cc08941e451518c179d>>
 * @relayHash dcabc24ecbfe7083e6c53d7bf69364b8
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID dcabc24ecbfe7083e6c53d7bf69364b8

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emails"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "emails",
        "variableName": "emails"
      }
    ],
    "concreteType": "CensorUsersResponse",
    "kind": "LinkedField",
    "name": "censorUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failedUsers",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CensorUsersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CensorUsersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "dcabc24ecbfe7083e6c53d7bf69364b8",
    "metadata": {},
    "name": "CensorUsersMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "908ce741c03c11a13fd2023044488313";

export default node;
